module.exports = __webpack_public_path__ + "static/media/25.9892dccf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/25.jpg
// module id = 558
// module chunks = 0